import CustomMarker from "./CustomMarker";

export default class GoogleMap {
    constructor(node) {
        this.node = node;
        this.map = null;
        this.markers = [];
        this.zoom = 48;
    }

    mount() {
        this.map = new google.maps.Map(this.node, {
            zoom: 8,
            center: {
                lat: 49.4,
                lng: 7.1
            },
            maxZoom: 20,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
            styles: [
                {
                    featureType: "poi",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                }
            ]
        });
        this.map.addListener("zoom_changed", () => {
            this.zoom = this.map.getZoom();
        });
    }

    autoCenter(coordList = [], zoomOffset = 0) {
        if (coordList.length === 0) {
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        coordList.forEach(coord => {
            bounds.extend(new google.maps.LatLng(coord.lat, coord.lon));
        });
        this.map.fitBounds(bounds, 100);
        this.map.setZoom(this.map.getZoom() + zoomOffset);
    }

    focusCoords(coords) {
        this.autoCenter([coords]);
    }

    clearMarkers() {
        this.markers.forEach(m => {
            m.clearFromMap();
        });
    }

    addMarker(latitude, longitude, classname = "") {
        const markerClass = CustomMarker();
        const marker = new markerClass(new google.maps.LatLng(latitude, longitude), classname);
        this.markers.push(marker);
        marker.setMap(this.map);
        return marker;
    }
}
